<template>
  <v-dialog
    :model-value="dialog"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    max-width="500px"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title class="headline">
        Puesto de empaquetado
      </v-card-title>

      <v-card-text>
          <div class="text-left mt-4 mb-4">
            <v-label class="mb-2">Escanea tu puesto de empaquetado</v-label>
            <v-text-field
              ref="locationInput"
              v-model="scannedLocation"
              label="Código de ubicación"
              density="comfortable"
              :loading="loading"
              @keyup.enter="handleScan"
              autofocus
              clearable
              hint="Para comenzar el empaquetado necesitas definir tu ubicación actual"
              :persistent-hint="true"
            >
              <template #prepend-inner>
                <v-icon
                  class="fa-solid fa-barcode mr-2"
                  style="margin-top: 4px; cursor: pointer"
                  >mdi-map-marker</v-icon
                >
              </template>
            </v-text-field>
          </div>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { zonaService } from "@/libs/ws/zonaService";

export default {
  name: "ModalScanLocation",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scannedLocation: "",
      loading: false,
      hasError: false,
      errorMessage: "",
    };
  },
  emits: ["close", "location-scanned"],
  mounted() {
    this.focusInput();
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.focusInput();
        });
      }
    },
  },
  methods: {
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.locationInput) {
          this.$refs.locationInput.focus();
        }
      });
    },

    clearError() {
      this.hasError = false;
      this.errorMessage = "";
    },

    handleScan() {
      console.log("Ubicación escaneada:", this.scannedLocation);
      
      if (this.scannedLocation && this.scannedLocation.trim() !== "") {
        
        this.$emit('location-scanned', this.scannedLocation.trim());
        this.scannedLocation = "";
      }
    },



  },
};
</script>

<style scoped>
.headline {
  font-weight: 500;
}
</style>
